import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type SectionHeadingProps = {
  children: ReactNode;
  className?: string;
  as?: "h1" | "h2" | "h3";
};

export function SectionHeading({ 
  children, 
  className, 
  as: Tag = "h2" 
}: SectionHeadingProps) {
  return (
    <Tag
      className={cn(
        "text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground",
        className
      )}
    >
      {children}
    </Tag>
  );
}

type SectionSubheadingProps = {
  children: ReactNode;
  className?: string;
};

export function SectionSubheading({ children, className }: SectionSubheadingProps) {
  return (
    <p
      className={cn(
        "text-base sm:text-lg md:text-xl text-muted-foreground max-w-2xl",
        className
      )}
    >
      {children}
    </p>
  );
}

